import { MouseEvent } from 'react';
import { Tab, TabGroup } from '@carbonify/ui';
import clsx from 'clsx';
import { YearOption } from 'services/productOptions/types';

import styles from './ProductsModule.module.css';

interface Props {
  options: YearOption[];
  onChange: (ubaYears: string) => void;
  value?: string;
  className?: string;
}

export default function UbaYearSelector({ options, value, onChange, className }: Props) {
  const handleTabClick = ({ currentTarget }: MouseEvent<HTMLButtonElement>) => {
    const ubaYear = currentTarget.getAttribute('data-year');
    if (ubaYear) onChange(ubaYear);
  };

  return (
    <TabGroup className={clsx(styles.ubaYears, className)}>
      {options.map(({ label, key }) => (
        <Tab
          key={key}
          active={key === value}
          data-year={key}
          onClick={handleTabClick}
          iconOnly
          className={styles.ubaYearsLabel}
        >
          {label}
        </Tab>
      ))}
    </TabGroup>
  );
}
